import { Component, OnInit } from '@angular/core';
import {
  EntidadEmpresarial, InformacionUsuarioEntity,
  ParametrosImprimirAdmisionEntity, FiltrosImprimirAdmisionEntity, InformacionAfiliadoEntity,
  AgrupacionAdmisionPorEmpresaEntity, InformacionDetalleAdmisionEntity,
  AgrupacionAdmisionPorPuntoAtencionEntity, EmpresaAdmision, ReporteAdmisionEntity,
  AgrupacionAnticipoAdmisionEmpresaEntity, InformacionAnticipoAdmisionEntity, AgrupacionAdmisionPorTipoEntity
} from '../../../../services/servicio-imprimir-admision.service';
import { ActivatedRoute } from '@angular/router';
import { ServicioUtilService } from '../../../../services/servicio-util.service';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
  selector: 'app-reporte-imprimir-admision',
  templateUrl: './reporte-imprimir-admision.component.html',
  styleUrls: ['./reporte-imprimir-admision.component.css']
})
export class ReporteImprimirAdmisionComponent implements OnInit {
  loading: boolean;
  fechaImpresion: Date;
  empresaSelected: EmpresaAdmision;
  empresasSelected: EmpresaAdmision[];

  mensajeError: string;
  ocultarDetalle: boolean;

  totalServicios: number;
  totalSuministros: number;
  totalIva: number;
  totalAtencion: number;
  montoLetras: string;

  filtrosSeleccionados: FiltrosImprimirAdmisionEntity;
  agrupacionEmpresas: AgrupacionAdmisionPorEmpresaEntity[] = [];
  agrupacionAnticipos: AgrupacionAnticipoAdmisionEmpresaEntity[] = [];

  public parametrosImprimirAdmision: ParametrosImprimirAdmisionEntity = {
    codigoBaseDatos: '',
    uncoSede: '',
    uncoLogin: '',
    uncoAdmision: '',
  };

  public filtrosImprimirAdmision: FiltrosImprimirAdmisionEntity = {
    codigoBaseDatos: '',
    uncoAdmisionEmpresa: '',
    ocultarDetalle: false,
  };

  public entidadEmpresarial: EntidadEmpresarial = {
    identificacionTributaria: '',
    digitoVerificacion: '',
    descripcion: '',
    direccion: '',
    telefono: '',
    logoUrl: '',
    codigoPrestador: '',
  };

  public informacionUsuario: InformacionUsuarioEntity = {
    nombreUsuario: '',
    codigoBarrasImprime: '',
  };

  public informacionAfiliado: InformacionAfiliadoEntity = {
    consecutivoAdmision: '',
    descripcionEmpresa: '',
    descripcionEstadoAdmision: '',
    descripcionEstratoAfiliado: '',
    descripcionSede: '',
    descripcionTipoAfiliado: '',
    direccionAfiliado: '',
    edad: '',
    fechaAdmision: '',
    fechaNacimiento: '',
    nombreAfiliado: '',
    numeroIdentificacionAfiliado: '',
    telefonoAfiliado: '',
    uncoSede: 0,
    valorTotalAtencion: '',
    ValorTotalIva: '',
    ValorTotalServicios: '',
    ValorTotalSuministros: '',
  };

  constructor(private activatedRoute: ActivatedRoute,
    private servicioUtil: ServicioUtilService) {
    this.activatedRoute.params.subscribe(params => {
      this.parametrosImprimirAdmision.codigoBaseDatos = params['codigoBaseDatos'];
      this.parametrosImprimirAdmision.uncoSede = params['uncoSede'];
      this.parametrosImprimirAdmision.uncoLogin = params['uncoLogin'];
      this.parametrosImprimirAdmision.uncoAdmision = params['uncoAdmision'];
      this.filtrosSeleccionados = this.filtrosImprimirAdmision;
      this.loading = true;
      this.mensajeError = null;
    });
  }

  ngOnInit() {  }

  public onFiltrosCompletados(obj: FiltrosImprimirAdmisionEntity) {
    this.filtrosSeleccionados = obj;
    this.filtrosSeleccionados.codigoBaseDatos = this.parametrosImprimirAdmision.codigoBaseDatos;
    this.fechaImpresion = new Date();
    this.loading = false;
  }

  // Evento recibido cuando esta cargando
  public updateLoading(event: any) {
    this.mensajeError = null;
    this.loading = true;
  }

  // Evento recibido cuando es error
  public updateError(error: string) {
    this.mensajeError = error;
    this.loading = false;
  }

  // Evento recibido cuando existen datos.
  public updateData(data: ReporteAdmisionEntity) {
    this.entidadEmpresarial = data.entidad;
    this.informacionUsuario = data.usuario;
    this.informacionAfiliado = data.afiliado;
    this.empresaSelected = data.empresa;
    this.ocultarDetalle = data.detalle === 0;
    this.fechaImpresion = new Date();

    this.totalServicios = 0;
    this.totalSuministros = 0;
    this.totalIva = 0;
    this.totalAtencion = 0;
    this.montoLetras = '';

    this.agrupacionEmpresas = this.agruparEmpresas(data.detalleAdmision);
    this.agrupacionAnticipos = this.agruparAnticipos(data.anticipos);

    this.getMontoLetras(this.totalAtencion, () => {
      this.loading = false;
      this.mensajeError = null;
    });
  }

  // Agrupamiento
  public agruparEmpresas(data: InformacionDetalleAdmisionEntity[]): AgrupacionAdmisionPorEmpresaEntity[] {
    const gruposEmpresa: AgrupacionAdmisionPorEmpresaEntity[] = [];

    data.forEach((d: InformacionDetalleAdmisionEntity) => {

      if (d.identificador === 'P') {
        this.totalServicios += this.getSubtotal(d);
      } else if (d.identificador === 'S') {
        this.totalSuministros += this.getSubtotal(d);
      }
      this.totalAtencion += d.valorTotal;
      this.totalIva += this.getIva(d);

      const empresa = d.descripcionEmpresa + ' ' + d.identificacionEmpresa;
      const grupoEmpresaIndex = gruposEmpresa.findIndex((f: AgrupacionAdmisionPorEmpresaEntity) => {
        return f.empresa === empresa;
      });

      if (grupoEmpresaIndex === -1) {
        const grupoEmpresa: AgrupacionAdmisionPorEmpresaEntity = {
          empresa : empresa,
          valor : d.valorTotal,
          detalles : [d],
          puntosAtencion : []
        };
        gruposEmpresa.push(grupoEmpresa);
      } else {
        gruposEmpresa[grupoEmpresaIndex].valor += d.valorTotal;
        gruposEmpresa[grupoEmpresaIndex].detalles.push(d);
      }
    });

    gruposEmpresa.forEach((g: AgrupacionAdmisionPorEmpresaEntity) => {
      g.puntosAtencion = this.agruparPuntosAtencion(g.detalles);
      g.detalles = null;
    });

    return gruposEmpresa;
  }

  public agruparPuntosAtencion(data: InformacionDetalleAdmisionEntity[]): AgrupacionAdmisionPorPuntoAtencionEntity[] {
    const grupoPuntosAtencion: AgrupacionAdmisionPorPuntoAtencionEntity[] = [];

    data.forEach((d: InformacionDetalleAdmisionEntity) => {
      const puntoAtencion = d.descripcionPuntoAtencion;
      const puntoAtencionIndex = grupoPuntosAtencion.findIndex((f: AgrupacionAdmisionPorPuntoAtencionEntity) => {
        return f.puntoAtencion === puntoAtencion;
      });

      if (puntoAtencionIndex === -1) {
        const grupoPuntoAtencion: AgrupacionAdmisionPorPuntoAtencionEntity = {
          puntoAtencion : puntoAtencion,
          valor : d.valorTotal,
          detalles : [d],
          tipos : []
        };
        grupoPuntosAtencion.push(grupoPuntoAtencion);
      } else {
        grupoPuntosAtencion[puntoAtencionIndex].valor += d.valorTotal;
        grupoPuntosAtencion[puntoAtencionIndex].detalles.push(d);
      }
    });

    grupoPuntosAtencion.forEach((g: AgrupacionAdmisionPorPuntoAtencionEntity) => {
      g.tipos = this.agruparTipos(g.detalles);
      g.detalles = null;
    });

    return grupoPuntosAtencion;
  }

  public agruparTipos(data: InformacionDetalleAdmisionEntity[]): AgrupacionAdmisionPorTipoEntity[] {
    const grupoTipos: AgrupacionAdmisionPorTipoEntity[] = [];

    data.forEach((d: InformacionDetalleAdmisionEntity) => {
      const tipo = d.identificador;
      const tipoIndex = grupoTipos.findIndex((f: AgrupacionAdmisionPorTipoEntity) => {
        return f.tipo === tipo;
      });

      if (tipoIndex === -1) {
        const tipoAgrupacion: AgrupacionAdmisionPorTipoEntity = {
          tipo : tipo,
          descripcion : tipo === 'P' ? 'Servicios y Procedimientos' : (tipo === 'S' ? 'Medicamentos y Suministros' : ''),
          valor : d.valorTotal,
          detalles : [d]
        };
        grupoTipos.push(tipoAgrupacion);
      } else {
        grupoTipos[tipoIndex].valor += d.valorTotal;
        grupoTipos[tipoIndex].detalles.push(d);
      }

    });

    return grupoTipos;
  }

  public agruparAnticipos(data: InformacionAnticipoAdmisionEntity[]): AgrupacionAnticipoAdmisionEmpresaEntity[] {
    const grupoAnticipos: AgrupacionAnticipoAdmisionEmpresaEntity[] = [];

    data.forEach((a: InformacionAnticipoAdmisionEntity) => {
      const empresa = a.descripcionEmpresa;
      const anticipoIndex = grupoAnticipos.findIndex((f: AgrupacionAnticipoAdmisionEmpresaEntity) => {
        return f.empresa === empresa;
      });

      if (anticipoIndex === -1) {
        const grupoAnticipo: AgrupacionAnticipoAdmisionEmpresaEntity = {
          empresa : empresa,
          valor : a.valor,
          detalles : [a]
        };
        grupoAnticipos.push(grupoAnticipo);
      } else {
        grupoAnticipos[anticipoIndex].valor += a.valor;
        grupoAnticipos[anticipoIndex].detalles.push(a);
      }

    });


    return grupoAnticipos;
  }

  // Obtener Datos
  async getMontoLetras(value: number, fn: Function) {
    try {
      const response = await this.servicioUtil.getMontoEnLetras(this.parametrosImprimirAdmision.codigoBaseDatos, value);
      if (response != null) {
        response.subscribe((data: any) => {
          this.montoLetras = data.montoLetras;
          fn();
        }, (err: HttpErrorResponse) => {
          console.error(`getMontoLetras()`, err);
          this.updateError('<i class="fa fa-warning"></i> Error grave al realizar calculo de atención, reporte caso al administrador');
        });
      }
    } catch (e) {
      this.updateError('<i class="fa fa-warning"></i> Error grave al realizar calculo de atención, reporte caso al administrador');
    }
  }

  // Determina si es posible mostrar datos
  public isPrepare() {
    return !this.loading && !this.mensajeError;
  }

  public getIva(data: InformacionDetalleAdmisionEntity): number {
    return ((data.cantidad * data.valorUnitario) * data.valorPorcentaje) / 100;
  }

  public getSubtotal(data: InformacionDetalleAdmisionEntity): number {
    return (data.cantidad * data.valorUnitario);
  }

}
